export const services = [
  {
    id: 1,
    title: "Newborn Photography",
    shortDesc: "Timeless portraits of your newest arrival, crafted within the first two weeks of life.",
    longDesc:
      "Every yawn, every curl, every tiny detail — captured forever. Stephanie's newborn sessions are conducted in a calm, safe environment tailored entirely to your baby's comfort. Whether in-studio or on location, each session is a bespoke experience designed to produce heirloom-quality imagery.",
    icon: "ri-heart-line",
    href: "/services",
    image: "https://images-pw.pixieset.com/site/BAJyQr/y5V5JJ/002-20240304-4252fe92-1500.jpg",
    features: ["In-studio & on-location available", "Wardrobe provided or BYO", "Multiple session days if needed", "Heirloom print products"],
  },
  {
    id: 2,
    title: "Luxury Weddings",
    shortDesc: "Fine art wedding coverage that tells your love story with cinematic elegance.",
    longDesc:
      "Your wedding day is a once-in-a-lifetime event. Precious Keepsakes delivers full-day luxury wedding photography that seamlessly blends editorial artistry with heartfelt documentary storytelling. Every detail, every emotion — preserved with intention.",
    icon: "ri-sparkling-line",
    href: "/services",
    image: "https://images-pw.pixieset.com/site/BAJyQr/wdadAo/B1B-328cb125-1500.jpg",
    features: ["Full-day coverage available", "Second shooter option", "Engagement sessions", "Fine art albums"],
  },
  {
    id: 3,
    title: "Milestones & Memories",
    shortDesc: "From maternity glow to senior portraits — every chapter beautifully documented.",
    longDesc:
      "Life moves in chapters. Maternity, seniors, quinceañeras, sweet sixteens — each milestone deserves to be honored with images that reflect its full significance. Custom-tailored sessions that capture who you are right now, forever.",
    icon: "ri-camera-line",
    href: "/services",
    image: "https://images-pw.pixieset.com/site/BAJyQr/0PjQvm/18-430f468f-1500.jpg",
    features: ["Maternity sessions", "Senior portraits", "Quinceañera & Sweet 16", "On-location available"],
  },
];

export const allServices = [
  { title: "Newborn Photography", href: "/services" },
  { title: "Luxury Weddings", href: "/services" },
  { title: "Milestones & Memories", href: "/services" },
  { title: "Senior Portraits", href: "/services" },
  { title: "Quinceañera / Sweet 16", href: "/services" },
  { title: "Maternity", href: "/services" },
];